# require this directly after webpack
# v2/modules/module-view-app

window.ceregoMainCreateApp = angular.module("cerego.create", [
  "ngRoute"
  "ngPromiseExtras"
  "ngCookies"
  "ngSanitize"
  "cerego.layout"
  "cerego.moduleView"
]).config(['$routeProvider', ($routeProvider) ->
  $routeProvider
  .when Packs.iKnowRoutes.v2_sets_path(),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("index")
    controller  : 'setIndexCtrl'
    resolve:
      $product: -> 'create'
  .when Packs.iKnowRoutes.v2_partner_sets_path(":parentId"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("index")
    controller  : 'setIndexCtrl'
    resolve:
      $product: -> 'create'
  .when Packs.iKnowRoutes.new_v2_set_path(),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("new")
    controller  : 'newModuleCtrl'
    resolve:
      $product: -> 'create'
      CreateService: ['NewSetService', (NewSetService) -> NewSetService]
  .when Packs.iKnowRoutes.v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("show")
    controller  : 'showSetCtrl'
    resolve:
      $titleTag: -> ("js.title_tags.content")
      $product: -> 'create'
      $tab: -> 'items'
  .when Packs.iKnowRoutes.v3_create_course_set_path(":course_id", ":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("show")
    controller  : 'showSetCtrl'
    resolve:
      $titleTag: -> ("js.title_tags.content")
      $product: -> 'create'
      $tab: -> 'items'
  .when Packs.iKnowRoutes.edit_details_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("edit_details")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'edit_details'
  .when Packs.iKnowRoutes.edit_distractors_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("edit_distractors")
    controller  : 'editDistractorsCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'edit_distractors'
  .when Packs.iKnowRoutes.series_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("series")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'series'
  .when Packs.iKnowRoutes.new_v2_series_path(),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("new")
    controller  : 'newModuleCtrl'
    resolve:
      $product: -> 'create'
      CreateService: ['NewSeriesService', (NewSeriesService) -> NewSeriesService]
  .when Packs.iKnowRoutes.quick_entry_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("item_import")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'quick_entry'
      $itemMode: -> 'quickAdd'
  .when Packs.iKnowRoutes.paste_csv_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("item_import")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'paste_csv'
      $itemMode: -> 'paste'
  .when Packs.iKnowRoutes.memory_bank_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("memory_bank")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'memory_bank'
  .when Packs.iKnowRoutes.bulk_upload_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("item_import")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'bulk_upload'
      $itemMode: -> 'upload'
  .when Packs.iKnowRoutes.revision_history_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("revision_history")
    controller  : 'showSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'revision_history'
  .when Packs.iKnowRoutes.edit_details_v2_create_series_path(":series_id"),
    templateUrl : Packs.iKnowRoutes.series_v2_templates_path("show")
    controller  : 'showSeriesCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'edit_details'
  .when Packs.iKnowRoutes.memory_bank_v2_create_series_path(":series_id"),
    templateUrl : Packs.iKnowRoutes.series_v2_templates_path("show")
    controller  : 'showSeriesCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'memory_bank'
  .when Packs.iKnowRoutes.collaborators_v2_create_set_path(":set_id"),
    templateUrl : Packs.iKnowRoutes.sets_v2_templates_path("collaborators")
    controller  : 'collaboratorsSetCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'collaborators'
  .when Packs.iKnowRoutes.v2_create_series_path(":series_id"),
    templateUrl : Packs.iKnowRoutes.series_v2_templates_path("show")
    controller  : 'showSeriesCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'sets'
  .when Packs.iKnowRoutes.v3_create_course_series_path(":course_id", ":series_id"),
    templateUrl : Packs.iKnowRoutes.series_v2_templates_path("show")
    controller  : 'showSeriesCtrl'
    resolve:
      $product: -> 'create'
      $tab: -> 'sets'
  .when Packs.iKnowRoutes.v3_lti_redirect_create_path(),
    templateUrl : Packs.iKnowRoutes.common_v3_templates_path("lti_redirect")
    controller  : 'createLtiRedirectCtrl'
  .otherwise
    template : "<div></div>"
    controller: ['$window', ($window) ->
      $window.location.href = Packs.iKnowRoutes.v3_signin_path()
    ]
])
